import { render, staticRenderFns } from "./ClearRegistrationsPage.vue?vue&type=template&id=37b87c4b"
import script from "./ClearRegistrationsPage.vue?vue&type=script&lang=js"
export * from "./ClearRegistrationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports